import { render, staticRenderFns } from "./PremiumIncome.vue?vue&type=template&id=ca344fc8&"
import script from "./PremiumIncome.vue?vue&type=script&lang=js&"
export * from "./PremiumIncome.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports